import withStyles from "@material-ui/core/styles/withStyles";
import "react-toastify/dist/ReactToastify.css";
import { useStyles } from "./styles";
import { PENDING_TEXT } from "../../constants/index";

function ClaimAmount({ item }) {
  return item?.claimed_amount
    ? `₹${Number(item?.claimed_amount).toLocaleString("en")}`
    : PENDING_TEXT;
}

export default withStyles(useStyles, { withTheme: true })(ClaimAmount);
